import { DynamicPlaceholderPlugin } from "@html_editor/others/dynamic_placeholder_plugin";
import { QWebPlugin } from "@html_editor/others/qweb_plugin";

export const DYNAMIC_PLACEHOLDER_PLUGINS = [DynamicPlaceholderPlugin, QWebPlugin];
